import { Button, Card, SectionLabel, ViewTab, ViewTabList } from '@wundo/ui';
import type { RoleplayMode } from '@wundo/shared/roleplay.ts';
import { m } from '@/paraglide/messages.js';

const MODES = [
  { value: 'voice', label: m.practice_session_mode_voice() },
  { value: 'chat', label: m.practice_session_mode_chat() },
] as const satisfies readonly { value: RoleplayMode; label: string }[];

export interface PracticeSessionStartProps {
  mode: RoleplayMode;
  starting: boolean;
  failed: boolean;
  onModeChange: (mode: RoleplayMode) => void;
  onBegin: () => void;
}

/**
 * How you want to have the conversation, and the button that starts it. Voice
 * is the default. Nothing here touches the microphone — the audio check after
 * it asks for it.
 */
export function PracticeSessionStart({
  mode,
  starting,
  failed,
  onModeChange,
  onBegin,
}: PracticeSessionStartProps) {
  return (
    <Card as='section' tone='accent'>
      <div className='flex flex-col items-stretch gap-3.5 agenda:flex-row agenda:flex-wrap agenda:items-center agenda:justify-center agenda:gap-5'>
        <SectionLabel as='h2' className='text-center'>
          {m.practice_session_how()}
        </SectionLabel>

        <ViewTabList
          aria-label={m.practice_session_mode()}
          className='w-full agenda:w-fit'
        >
          {MODES.map((option) => (
            <ViewTab
              key={option.value}
              active={option.value === mode}
              className='flex-1 agenda:flex-none'
              onClick={() => onModeChange(option.value)}
            >
              {option.label}
            </ViewTab>
          ))}
        </ViewTabList>

        <Button variant='accent' size='lg' disabled={starting} onClick={onBegin}>
          {starting ? m.practice_session_beginning() : m.practice_session_begin()}
        </Button>
      </div>

      {failed && (
        <p role='alert' className='mt-3 text-center text-base text-danger'>
          {m.practice_session_begin_failed()}
        </p>
      )}
    </Card>
  );
}
